import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  userAgent = navigator.userAgent;

  getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    if (/android/i.test(this.userAgent)) return 'mobile';
    if (/iPad|iPhone|iPod/.test(this.userAgent) && !(window as any).MSStream) return 'mobile';
    if (/tablet|ipad|playbook|silk/i.test(this.userAgent)) return 'tablet';
    return 'desktop';
  }
  getDeviceInfo() {
    return {
      userAgent: this.userAgent,
      deviceType: this.getDeviceType(),
    };
  }
}
